// @flow

// sum of unicode code point integers of the first character of the first name
// (or 0 if not present) and the last character of the last name (or 0 if not present),
// mod the number of possible colors (4), and then index from the list of colors
// where the list of colors is ['yellow', 'green', 'magenta', 'purple']
export function getAvatarColor({
  firstName,
  lastName,
}: {
  firstName: ?string,
  lastName: ?string,
}) {
  try {
    const firstNameUnicodeInt = firstName
      ? [...firstName].shift().codePointAt(0)
      : 0
    const lastNameUnicodeInt = lastName ? [...lastName].pop().codePointAt(0) : 0
    return ['yellow', 'green', 'magenta', 'purple'][
      (firstNameUnicodeInt + lastNameUnicodeInt) % 4
    ]
  } catch (e) {
    return 'yellow'
  }
}
